import { render } from "./MainKardex.vue?vue&type=template&id=4ccd3686&scoped=true"
import script from "./MainKardex.vue?vue&type=script&lang=js"
export * from "./MainKardex.vue?vue&type=script&lang=js"

import "./MainKardex.vue?vue&type=style&index=0&id=4ccd3686&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccd3686"]])

export default __exports__